import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { role } from "../../Constants/role";
import Select from "react-tailwindcss-select";

const SuperCityAdminRoleModal = ({ admin, onClose, onSave }) => {
  const { t } = useTranslation();
  const [selectedRole, setSelectedRole] = useState( null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   if (admin?.roleId) {
  //     setSelectedRole(admin.roleId);
  //   }
  // }, [admin]);

  const handleRoleChange = (option) => {
    setSelectedRole(Number(option.value));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {

         let roleData = {
              roleId: selectedRole,
            };
      roleData.cityId = admin?.cities.map((c) => c.cityId);
      await onSave(roleData);
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to update role");
    } finally {
      setLoading(false);
    }
  };

  const roleOptions = [
    { value: role.TerminalAdmin, label: t("city_admin") },
    { value: role.contentCreator, label: t("citizen") },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full relative" 
         onMouseDown={(e) => {
         e.stopPropagation(); // ✅ THIS IS THE KEY
         }}>
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-black text-2xl"
         onMouseDown={(e) => {
            e.preventDefault(); // ✅ KEY
            e.stopPropagation(); // ✅ KEY
            onClose(); // close modal immediately
          }}
        >
          &times;
        </button>

        <h2 className="text-2xl font-bold mb-4 text-center">
          {t("change_Super_city_admin_role") || "Change Admin Role"}
        </h2>

        <div className="mb-4 p-3 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600">
            <strong>{t("super_city_admins") || "Super City Admin"}:</strong> {admin?.name}{" "}
          </p>
          <p className="text-sm text-gray-600">
            <strong>{t("email") || "Email"}:</strong> {admin?.email}
          </p>
          <p className="text-sm text-gray-600">
            <strong>{t("city") || "City"}:</strong> {admin?.cities?.map((city) => city.cityName).join(", ")}
          </p>
          <p className="text-sm text-gray-600">
            <strong>{t("current_role") || "Current Role"}:</strong>{" "}
            {(() => {
              const roleKey = Object.keys(role).find(
                (key) => role[key] === admin?.roleId
              );
              if (roleKey === "TerminalAdmin") return "City Admin";
              if (roleKey === "SuperAdmin" || roleKey === "superCityAdmin")
                return "Super City Admin";
              if (roleKey === "contentCreator") return "Citizen";
              return roleKey;
            })()}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block font-medium mb-2">
              {t("role") || "New Role"}{" "}
              <span className="text-red-500">*</span>
            </label>
            {/* <select
                            value={selectedRole || ''}
                            onChange={handleRoleChange}
                            className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring focus:ring-blue-300"
                            required
                        >
                            <option value="">{t("select_role") || "Select Role"}</option>
                            {roleOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select> */}
            <Select
              primaryColor="indigo"
              value={
                roleOptions.find((opt) => Number(opt.value) === selectedRole) ||
                null
              }
              onChange={handleRoleChange}
              options={roleOptions}
              classNames={{
                menu: "max-h-40 overflow-y-auto",
                list: "space-y-1",
                option: "py-1 px-2",
              }}
            />
            <p className="text-xs text-gray-500 mt-1">
              {t("change_role_city_admin_citizen") ||
                "Change role to City Admin or Citizen"}
            </p>
          </div>

          {error && <p className="text-sm text-red-500 text-center">{error}</p>}

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
              onMouseDown={(e) => {
            e.preventDefault(); // ✅ KEY
            e.stopPropagation(); // ✅ KEY
            onClose(); // close modal immediately
          }}
              disabled={loading}
            >
              {t("cancel") || "Cancel"}
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
              disabled={loading || !selectedRole}
            >
              {loading
                ? t("saving") || "Saving..."
                : t("update_role") || "Update Role"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperCityAdminRoleModal;